import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const RotateBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;

  background-color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const WaterMarkCss = css`
  color: #f7f7f71a;
  background: unset;
  -webkit-text-fill-color: unset;
`;
